module.exports = __webpack_public_path__ + "static/media/exploring_fun.3be19dbd.png";